import React, { Component } from 'react';

import defaultStyles from './default.less';

interface Props {
	children: React.ReactNode;
	styles: { table: string };
}

export default class Table extends Component<Props> {
	static defaultProps = {
		styles: defaultStyles,
	};

	render() {
		const { children, styles } = this.props;

		return <table className={styles.table}>{children}</table>;
	}
}
